import { render, staticRenderFns } from "./ListSimulasiAnggaran.vue?vue&type=template&id=bb997568&"
import script from "./ListSimulasiAnggaran.vue?vue&type=script&lang=js&"
export * from "./ListSimulasiAnggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports